import { call, put } from 'redux-saga/effects';
import api from '@/services/api';
import ReposActions, { ReposTypes } from '@/store/ducks/repos';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import Toast from '@/utils/toast';
import { getAPIErrorPayload } from '@/utils/commonFunctions';

export function* getReposRequest() {
  try {
    const {
      API_URLS: { repos },
    } = GLOBAL_CONSTANTS;
    const { data } = yield call(api.get, repos);
    yield put(ReposActions.getReposSuccess(data?.data ?? []));
  } catch (error) {
    Toast.error(error?.message);
    yield put(ReposActions.getReposFailure(getAPIErrorPayload(ReposTypes.GET_REPOS_REQUEST, error)));
  }
}
